import React, { useState } from 'react';

const DistanceCalc = () => {
  const [from, setFrom] = useState({ city: '', district: '' });
  const [to, setTo] = useState({ city: '', district: '' });

  const handleCalculate = () => {
    alert(`Distance: Kathmandu to Pokhara = 200km`);
  };

  return (
    <section className="container my-5"><br/><br/>
      <h2 className="text-center mb-5 section-title">
        <i className="fas fa-route me-2"></i> Distance Calculator
      </h2>
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="calc-card">
            <div className="row g-4">
              <div className="col-md-6">
                <h6 className="fw-bold mb-4 text-primary"><i className="fas fa-map-marker-alt me-2"></i>From</h6>
                <input className="form-control mb-3 form-large" placeholder="City/Municipality"/>
                <input className="form-control form-large" placeholder="District"/>
              </div>
              <div className="col-md-6">
                <h6 className="fw-bold mb-4 text-success"><i className="fas fa-flag-checkered me-2"></i>To</h6>
                <input className="form-control mb-3 form-large" placeholder="Destination City"/>
                <input className="form-control form-large" placeholder="District"/>
              </div>
              <div className="col-12">
                <button className="btn btn-primary w-100 book-main-btns fs-5 py-4" onClick={handleCalculate}>
                  Calculate Distance & Cost
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DistanceCalc;
